/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

import mapStyles from "./map-styles";

function new_map($el) {

    // var
    var $markers = $el.find('.marker');
    let markerCount = $markers.length ?? 0;
    var zoom = $el.data('zoomLevel') || 16;
    var mapType = $el.data('mapType');

    // vars
    var args = {
        zoom: zoom,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: mapType,
        styles: mapStyles
    };


    // create map
    var map = new google.maps.Map($el[0], args);


    // add a markers reference
    map.markers = [];


    // add markers
    $markers.each(function () {

        add_marker($(this), map, markerCount);

    });


    // center map
    center_map(map);


    // return
    return map;

}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker($marker, map, markerCount) {

    // var
    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
    var url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 70.6 91.3" style="enable-background:new 0 0 70.6 91.3;" xml:space="preserve"><path fill="#DE0B1C" d="M35.3,0C15.8,0,0,15.8,0,35.3c0,28.5,35.3,56,35.3,56s35.3-26.5,35.3-56C70.6,15.8,54.8,0,35.3,0z M35.3,46.1c-7,0-12.8-5.7-12.8-12.8s5.8-12.7,12.8-12.7s12.8,5.7,12.8,12.8S42.3,46.1,35.3,46.1L35.3,46.1z"/></svg>');
    if(markerCount > 1) {
        url = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa('<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 130 130" style="enable-background:new 0 0 130 130" xml:space="preserve"><style type="text/css">.st0{fill:#fff}</style><g><rect id="XMLID_148_" x="-0.2" y="-0.2" width="130.39" height="130.39"/><g id="XMLID_127_"><path id="XMLID_143_" class="st0" d="M17.18,48.94c-1.57-2.56-2.19-5.82-1.59-9.59c1.32-8.34,9.57-14.2,17.51-14.2c3.33,0,6.35,1.03,8.7,2.85l4.02-3.4l2.39,2.93l-3.81,3.26c1.54,2.27,2.24,5.24,1.72,8.56c-1.41,8.93-8.82,15.23-17.67,15.23c-3.52,0-6.51-0.99-8.74-2.82l-3.94,3.37l-2.39-2.92L17.18,48.94z M35.74,33.17c-1.03-0.66-2.32-1.06-3.75-1.06c-4.28,0-8.35,3.48-8.95,7.29c-0.25,1.57-0.11,3,0.43,4.21L35.74,33.17z M25.82,46.56c1.03,0.7,2.29,1.06,3.71,1.06c4.29,0,8.35-3.48,9.1-8.23c0.19-1.21,0.04-2.34-0.42-3.33L25.82,46.56z"/><path id="XMLID_141_" class="st0" d="M59.5,39.72c-0.94-0.55-2.3-0.92-3.44-0.92c-0.77,0-2.14,0.33-2.29,1.28c-0.2,1.28,1.86,1.46,2.74,1.65c3.01,0.62,5.12,2.09,4.57,5.56c-0.79,4.94-5.61,6.99-9.97,6.99c-2.67,0-5.18-0.77-7.23-2.16l3.15-4.65c1.21,0.95,3.32,1.9,4.97,1.9c0.84,0,2.15-0.4,2.31-1.43c0.23-1.46-1.84-1.54-3.84-2.09c-2-0.55-3.93-1.57-3.39-4.94c0.73-4.61,5.23-6.67,9.33-6.67c2.12,0,4.19,0.33,5.99,1.21L59.5,39.72z"/><path id="XMLID_139_" class="st0" d="M69.75,53.66h-6.66l2.11-13.29h-2.16l0.87-5.49h2.16l0.89-5.63h6.66l-0.89,5.63h3.77l-0.87,5.49h-3.77L69.75,53.66z"/><path id="XMLID_136_" class="st0" d="M96.08,45.39H82.06c-0.43,2.71,0.76,4.17,3.51,4.17c1.43,0,2.53-0.47,3.46-1.72h6.4c-1.76,4.43-6.29,6.44-10.57,6.44c-6.22,0-10.31-3.51-9.29-9.99c0.99-6.26,5.87-10.03,11.98-10.03c6.52,0,9.65,4.03,8.63,10.44L96.08,45.39z M90.5,41.55c-0.04-1.8-1.5-2.97-3.3-2.97c-1.94,0-3.71,1.03-4.42,2.97H90.5z"/><path id="XMLID_134_" class="st0" d="M105.24,37.96h0.07c1.64-2.3,4-3.33,6.6-3.33h1.28l-1.01,6.41c-0.83-0.52-1.7-0.62-2.72-0.62c-3.7,0-5,2.45-5.51,5.67l-1.2,7.57h-6.66l2.97-18.78h6.66L105.24,37.96z"/><path id="XMLID_132_" class="st0" d="M60.58,68.88l1.69-10.65h7.17l-4.37,27.61h-7.18l1.79-11.32H49.32l-1.79,11.32h-7.18l4.37-27.61h7.18l-1.69,10.65H60.58z"/><path id="XMLID_130_" class="st0" d="M76.83,67.06l-1.59,10.03c-0.38,2.38-0.06,4.06,2.69,4.06c2.75,0,3.6-1.69,3.98-4.06l1.59-10.03h6.66l-1.79,11.31c-0.98,6.19-5.64,8.1-11.28,8.1c-5.64,0-9.7-1.9-8.71-8.1l1.79-11.31H76.83z"/><path id="XMLID_128_" class="st0" d="M103.65,71.89c-0.94-0.55-2.31-0.91-3.45-0.91c-0.77,0-2.14,0.33-2.29,1.28c-0.2,1.28,1.86,1.46,2.74,1.65c3.01,0.62,5.12,2.08,4.57,5.56c-0.78,4.94-5.61,7-9.97,7c-2.67,0-5.19-0.77-7.24-2.16l3.15-4.65c1.21,0.95,3.33,1.91,4.98,1.91c0.84,0,2.15-0.4,2.31-1.43c0.23-1.46-1.85-1.54-3.85-2.09c-2-0.55-3.92-1.57-3.39-4.94c0.73-4.62,5.23-6.66,9.33-6.66c2.12,0,4.19,0.33,6,1.21L103.65,71.89z"/></g><g><path class="st0" d="M112.37,30.01c-1.51,0-2.58-1.13-2.58-2.62c0-1.58,1.19-2.62,2.58-2.62c1.37,0,2.56,1.04,2.56,2.62C114.93,28.97,113.74,30.01,112.37,30.01z M112.37,25.23c-1.13,0-2.02,0.89-2.02,2.16c0,1.19,0.77,2.16,2.02,2.16c1.12,0,2-0.88,2-2.16C114.37,26.12,113.49,25.23,112.37,25.23z M111.85,28.89h-0.48v-2.9h1.1c0.7,0,1.06,0.25,1.06,0.83c0,0.53-0.32,0.74-0.76,0.79l0.81,1.27h-0.54l-0.75-1.24h-0.45V28.89z M112.38,27.24c0.36,0,0.67-0.04,0.67-0.46c0-0.35-0.34-0.39-0.63-0.39h-0.57v0.85H112.38z"/></g></g></svg>');
    }
    var icon = {
        url: url,
        scaledSize: new google.maps.Size(35, 35)
    };

    // create marker
    var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: icon
    });

    // add to array
    map.markers.push(marker);

    marker.addListener('click', function(m) {
        var url = 'https://www.google.com/maps/dir/?api=1&destination=' + m.latLng.lat() + ',' + m.latLng.lng();
        window.open(url, '_blank');
    });

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map(map) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {

        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

        bounds.extend(latlng);
    });

    // only 1 marker?
    if (map.markers.length == 1) {
        // set center of map
        map.setCenter(bounds.getCenter());
    }
    else {
        // fit to bounds
        map.fitBounds(bounds);
    }

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;

var initMap = function() {

    $('.acf-map:not(.initialized)').each(function () {
        var $this = $(this);

        if (window.google === undefined || window.google.maps === undefined) {
            return;
        }

        // create map
        map = new_map($this);

        $this.addClass('initialized');

    });

    if (window.initSubfieldMap) {
        window.initSubfieldMap();
    }

};

window.initMap = initMap;
